<mat-form-field class="full-width">
    <input matInput type="text" [placeholder]="isInputFocused ? '' : 'Buscar Empleado'" [formControl]="searchControl" 
           [matAutocomplete]="auto" (focus)="isInputFocused = true" (blur)="isInputFocused = false">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedOption($event)">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ displayOption(option) }}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>
  